import React, { useState } from 'react';
import { AppBar, Toolbar, IconButton, Menu, MenuItem, Typography, Box, Button, Container } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import { Link, useLocation } from 'react-router-dom';

const navigation = [
  { label: 'Home', path: '/' },
  { label: 'About', path: '/about' },
  { label: 'Contact', path: '/contact' },
];

function Header() {
  const location = useLocation();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        bgcolor: 'rgba(11, 9, 9, 0.9)',
        backdropFilter: 'blur(14px)',
        borderBottom: '1px solid rgba(248, 241, 231, 0.12)',
      }}
    >
      <Container maxWidth="xl" disableGutters>
        <Toolbar sx={{ minHeight: { xs: 70, md: 78 }, px: { xs: 2, sm: 3, md: 5 }, gap: 3 }}>
          <Box
            component={Link}
            to="/"
            aria-label="Malpractice Band home"
            sx={{ display: 'flex', alignItems: 'center', color: 'inherit', textDecoration: 'none', mr: 'auto' }}
          >
          <Box
            component="img"
            src={require('../assets/malpractice_showband_icon.png')}
            alt="Malpractice Band Logo"
            sx={{
              width: { xs: 40, md: 46 },
              height: { xs: 40, md: 46 },
              borderRadius: '50%',
              mr: 1.5,
            }}
          />
          <Typography sx={{ color: 'text.primary', fontWeight: 800, fontSize: { xs: '1.05rem', sm: '1.2rem' } }}>
            MALPRACTICE
          </Typography>
        </Box>
        <Box component="nav" aria-label="Primary navigation" sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', gap: 0.5 }}>
          {navigation.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <Button
                key={item.path}
                component={Link}
                to={item.path}
                aria-current={isActive ? 'page' : undefined}
                sx={{
                  minWidth: 0,
                  color: isActive ? 'secondary.main' : 'text.primary',
                  px: 1.75,
                  '&:hover': { color: 'secondary.main', bgcolor: 'rgba(242, 184, 75, 0.08)' },
                }}
              >
                {item.label}
              </Button>
            );
          })}
        </Box>
        <Button
          component={Link}
          to="/contact"
          variant="contained"
          endIcon={<ArrowOutwardIcon />}
          sx={{ display: { xs: 'none', sm: 'inline-flex' }, bgcolor: 'secondary.main', color: '#110c0a', '&:hover': { bgcolor: '#ffd06f' } }}
        >
          Book the band
        </Button>
        <IconButton
          aria-label="menu"
          onClick={handleMenuOpen}
          sx={{ display: { xs: 'flex', md: 'none' }, width: 48, height: 48, color: 'text.primary' }}
        >
          <MenuIcon />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          sx={{ display: { xs: 'block', md: 'none' } }}
          PaperProps={{ sx: { bgcolor: '#15110f', color: 'text.primary', border: '1px solid rgba(248, 241, 231, 0.15)', minWidth: 200 } }}
        >
          {navigation.map((item) => (
            <MenuItem
              key={item.path}
              component={Link}
              to={item.path}
              selected={location.pathname === item.path}
              onClick={handleMenuClose}
              sx={{ minHeight: 48, '&.Mui-selected': { bgcolor: 'rgba(233, 93, 63, 0.18)', color: 'secondary.main' } }}
            >
              {item.label}
            </MenuItem>
          ))}
        </Menu>
        </Toolbar>
      </Container>
    </AppBar>
  );
}

export default Header;
